import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { fillString } from '@local_modules/generic/string-template.js'
import { createElementFromHtml } from '@local_modules/generic/dom/create-elements-from-html.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { renderElement } from '@local_modules/generic/dom/render-element.js'
import { listener } from './actions.js'

import htmlTemplateSelectLevel from './select-level.html'
import htmlTemplateSelect from './select.html'

/**
 *
 * @param {Object} options
 * @param {String} options.containerId
 * @param {String} options.groupLabel
 * @param {Function} options.onChange
 */
export function generateSelectLevel (options) {
  // console.log('generateSelectLevel', options)

  const buttonContainerId = options.containerId
  const groupLabel = options.groupLabel

  // Generate the group container
  const elementId = 'si_' + generateRandomString(8)
  const selectContainerId = 'select_container_' + generateRandomString(8)

  const element = fillString(htmlTemplateSelectLevel, {
    selectGroupElementId: elementId,
    selectContainerId,
    selectLabel: groupLabel
  })

  const DOMelement = setElementHtml(buttonContainerId, element)
  if (!DOMelement) return

  return generateSelect({
    selectOptions: options.selectOptions,
    selectedValue: options.selectedValue,
    containerId: selectContainerId,
    onChange: options.onChange
  })
}

/**
 *
 * @param {Object} options
 * @param {Object[]} options.selectOptions
 * @param {String} options.selectedValue
 * @param {String} [options.containerId]
 * @param {Function} options.onChange
 */
export function generateSelect (options) {
  // console.log('generateSelect', options)

  const selectInstance = {
    selectOptions: options.selectOptions,
    selectedValue: options.selectedValue || null,
    onChange: function () {
      return options.onChange?.(selectInstance.selectedValue, selectInstance)
    },
    update: function (params) {
      updateSelect(selectInstance, params)
    }
  }

  // Generate the container
  const elementId = 'select_' + generateRandomString(8)
  selectInstance.elementId = elementId

  const elementHtml = fillString(htmlTemplateSelect, { elementId })
  // selectInstance.elementHtml = elementHtml

  const selectElement = createElementFromHtml(elementHtml)
  selectInstance.DOMelement = selectElement
  selectInstance.selectElement = selectElement.querySelector('select')

  // Add the options
  generateOptions(selectInstance)

  // Add listener
  listener(selectInstance)

  // Update to selected value

  if (options.containerId) {
    renderElement(options.containerId, selectElement)
  }

  return selectInstance
}

/**
 *
 * @param {*} selectInstance
 */
function generateOptions (selectInstance) {
  // console.log('generateOptions', selectInstance, selectInstance.selectedValue)

  if (!selectInstance.selectOptions) {
    selectInstance.DOMelement.innerHTML = 'No options'
  }

  const optionsHtmlArray = []
  selectInstance.selectOptions?.forEach(function (oneOption) {
    const option = Object.assign({}, oneOption)

    const isSelected = (selectInstance.selectedValue && selectInstance.selectedValue === oneOption.value)
    option.isSelected = isSelected
    const html = generateOptionHtml(option)
    optionsHtmlArray.push(html)
  })

  const optionsHtml = optionsHtmlArray.join('')
  selectInstance.selectElement.innerHTML = optionsHtml
}

function generateOptionHtml (options) {
  const optionHtml = `<option value="${options.value}" ${options.isSelected ? 'selected' : ''}>${options.label}</option>`

  return optionHtml
}

function updateSelect (selectInstance, params) {
  if (params.selected) {
    selectInstance.selectedValue = params.selected
  }

  if (params.selectOptions) {
    selectInstance.selectOptions = params.selectOptions
    generateOptions(selectInstance)
  }
}
